//src/components/materials/materialPopUp.js
import React from 'react';

const MaterialPopup = ({ materialText, show, onClose }) => {
  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 w- full " 
      onClick={onClose} // Close popup when clicking outside the content
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-8/12 overflow-y-auto mx-auto h-72 transform transition-transform duration-300 animate-slide-down"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <button
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold"
          onClick={onClose}
        >
          ×
        </button>
        <h3 className="text-xl font-semibold mb-4">Material Text</h3>
        <p className="text-gray-700">{materialText}</p>
      </div>
    </div>
  );
};

export default MaterialPopup;